module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "services-page"
    }
  }, [_c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      staticClass: "section",
      class: {
        'fp-auto-height': section.cta, 'align-bottom': section.alignBottom, 'get-started': section.getStarted, 'remove-spacer': section.removeSpacer
      },
      style: ({
        background: section.background
      })
    }, [_c('app-section', {
      attrs: {
        "index": index,
        "heading": section.heading,
        "content": section.content,
        "btnText": section.btnText,
        "image": section.image,
        "order": section.order,
        "button": section.button,
        "enter": section.enter,
        "animEnter": section.animEnter,
        "animLeave": section.animLeave,
        "appFooter": section.appFooter,
        "title": section.title,
        "subTitle": section.subTitle,
        "getStarted": section.getStarted,
        "wireframe": section.wireframe,
        "svg1": section.svg1,
        "svg2": section.svg2,
        "removeSpacer": section.removeSpacer
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "section fp-auto-height",
    attrs: {
      "id": "footer"
    }
  }, [_c('app-footer')], 1)], 2), _vm._v(" "), _c('ul', {
    staticClass: "container hidden-xs",
    attrs: {
      "id": "sidebar-nav"
    }
  }, [_c('li', [_c('a', {
    class: {
      'active': _vm.nav.section1
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(1)
      }
    }
  }, [_vm._v("Branding")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section2
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(2)
      }
    }
  }, [_vm._v("User Experience")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section3
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(3)
      }
    }
  }, [_vm._v("User Interface")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section4
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(4)
      }
    }
  }, [_vm._v("Polish")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section5
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(5)
      }
    }
  }, [_vm._v("Services")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      'active': _vm.nav.section6
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.navigate(6)
      }
    }
  }, [_vm._v("Get Started")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b9d4ef5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ServicesPage.vue
// module id = 79
// module chunks = 0